/* Wildgrain Reasons Mobile Carousel */

(function () {
  if (!window.FoxTheme || !window.FoxTheme.Carousel) return;

  const initReasonsCarousel = () => {
    const carousels = document.querySelectorAll('.wildgrain-reasons-carousel-mobile .wg-swiper');

    if (!carousels.length) return;

    carousels.forEach((carousel) => {
      // Avoid re-initialising on the same element
      if (carousel.__wgSwiperInit) return;

      const section = carousel.closest('.section');

      const options = {
        slidesPerView: 1,
        spaceBetween: 16,
        // Remove custom wrapperClass & slideClass to use defaults
        // (wrapperClass & slideClass left default: 'swiper-wrapper', 'swiper-slide')
        navigation: {
          nextEl: section.querySelector('.wg-swiper-button-next'),
          prevEl: section.querySelector('.wg-swiper-button-prev'),
        },
        pagination: {
          el: section.querySelector('.wg-swiper-pagination'),
          clickable: true,
        },
        threshold: 4,
        loop: false,
      };

      const slider = new window.FoxTheme.Carousel(carousel, options);
      slider.init();

      carousel.__wgSwiperInit = true; // mark as initialized
    });
  };

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReasonsCarousel);
  } else {
    initReasonsCarousel();
  }

  // Re-initialize when Shopify theme editor loads blocks or on resize (optional)
  document.addEventListener('shopify:section:load', initReasonsCarousel);
})();
